// Structural data only – no text. Names, summaries and details live in the
// per-language content files (src/i18n/content) and are merged in by usePlaces().
// Coordinates are only given where a source states them; a place without
// lat/lon is not pinned on the map.
export const basePlaces = [
  { id: 'nanovitsa', category: 'village', lat: 41.5511, lon: 25.5701 },
  { id: 'tatul', category: 'ancient', lat: 41.5536, lon: 25.5411, photo: 'tatul-panorama', area: 'tatul' },
  { id: 'perperikon', category: 'ancient', lat: 41.71472, lon: 25.46528, photo: 'perperikon-top' },
  { id: 'petrified-forest', category: 'nature' },
  { id: 'stone-mushrooms', category: 'nature', photo: 'stone-mushrooms' },
  { id: 'kardzhali-reservoir', category: 'water', lat: 41.6336, lon: 25.3406, photo: 'kardzhali-reservoir' },
  { id: 'rock-niches', category: 'heritage' },
  { id: 'ali-bey-house', category: 'heritage' },
  { id: 'borovets', category: 'nature' },
  { id: 'momchilgrad', category: 'town', lat: 41.5333, lon: 25.4167, photo: 'momchilgrad-square', area: 'momchilgrad' },
  { id: 'kardzhali', category: 'town', lat: 41.65, lon: 25.3667, photo: 'kardzhali-view', area: 'kardzhali' },
]
